import styled from 'styled-components';
interface Props{
  color: string
}
export const Container = styled.div`
height: 10px;
width: 10px;
min-height:10px;
border-radius: 100%;
margin-right: 5px;
background-color: ${props => props.color === 'green' ?'#91C35C': '#E14948'};

`